import apiFunctions from '..';
import {
  InviteUserRequest,
  UpdateUserActiveRequest,
  UpdateUserRolesRequest,
  UserSummary,
} from '../../types/users';

const usersEndpoint = 'users';

/** Loads application users visible to an authorized administrator. */
export const getUsers = () => apiFunctions.apiGet<UserSummary[]>(usersEndpoint);

/** Invites an OTP user through the Admin-only user API. */
export const inviteUser = (request: InviteUserRequest) =>
  apiFunctions.apiPostRequest<UserSummary>(`${usersEndpoint}/invitations`, request);

/** Sends a new login link to an existing active OTP user. */
export const resendLoginLink = (userId: number) =>
  apiFunctions.apiPostRequest<void>(`${usersEndpoint}/${userId}/login-link`, {});

/** Replaces a user's roles while the API preserves the mandatory Basic role. */
export const updateUserRoles = (userId: number, request: UpdateUserRolesRequest) =>
  apiFunctions.apiPut<UserSummary>(`${usersEndpoint}/${userId}/roles`, request);

/** Activates or deactivates an application user. */
export const updateUserActive = (userId: number, request: UpdateUserActiveRequest) =>
  apiFunctions.apiPut<UserSummary>(`${usersEndpoint}/${userId}/active`, request);

/** Permanently removes an application user. */
export const deleteUser = (userId: number) => apiFunctions.apiDelete(`${usersEndpoint}/${userId}`);
